import React from 'react';

function Footer() {
  return (
    <div className="footer">
      Hi I am <a href="https://www.albertofortes.com" title="Senior Front-end React, Gatsby, JavaScript developer. Open to heard about new opportunities as long-term contractor.">Alberto Fortes</a>. This is a weekend experiment working with ReactJs + The Movie Db API.
    </div>
  )
}

export default Footer;